import { render, staticRenderFns } from "./CourseLoads.vue?vue&type=template&id=5020bf50"
import script from "./CourseLoads.vue?vue&type=script&lang=js"
export * from "./CourseLoads.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports